import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelDynamic as _vModelDynamic, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "compare-container" }
const _hoisted_2 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_3 = {
  key: 1,
  class: "content"
}
const _hoisted_4 = { class: "compare-header" }
const _hoisted_5 = { class: "container-fluid px-4" }
const _hoisted_6 = { class: "d-flex flex-wrap justify-content-between align-items-center gap-3" }
const _hoisted_7 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_8 = {
  class: "view-toggle",
  role: "group",
  "aria-label": "Weergave kiezen"
}
const _hoisted_9 = ["aria-pressed"]
const _hoisted_10 = ["aria-pressed"]
const _hoisted_11 = ["aria-pressed", "disabled"]
const _hoisted_12 = { class: "badge bg-secondary" }
const _hoisted_13 = {
  id: "hoofdinhoud",
  tabindex: "-1"
}
const _hoisted_14 = { class: "container-fluid mt-4 px-4" }
const _hoisted_15 = {
  key: 0,
  class: "search-section"
}
const _hoisted_16 = { class: "input-group" }
const _hoisted_17 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_18 = ["aria-expanded"]
const _hoisted_19 = {
  key: 0,
  class: "badge bg-danger ms-1"
}
const _hoisted_20 = {
  key: 2,
  id: "vergelijk-filters",
  class: "filter-section mt-3"
}
const _hoisted_21 = { class: "card" }
const _hoisted_22 = { class: "card-header d-flex justify-content-between align-items-center" }
const _hoisted_23 = { class: "card-body" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = ["for"]
const _hoisted_26 = ["id", "onUpdate:modelValue"]
const _hoisted_27 = ["value"]
const _hoisted_28 = {
  key: 1,
  class: "a11y-fieldset"
}
const _hoisted_29 = { class: "form-label fw-bold" }
const _hoisted_30 = ["id", "type", "name", "value", "onUpdate:modelValue"]
const _hoisted_31 = ["for"]
const _hoisted_32 = { class: "mt-3" }
const _hoisted_33 = {
  class: "visually-hidden",
  "aria-live": "polite"
}
const _hoisted_34 = {
  key: 0,
  class: "container-fluid mt-4 px-4"
}
const _hoisted_35 = {
  key: 1,
  class: "container-fluid mt-4 px-4"
}
const _hoisted_36 = {
  key: 2,
  class: "container-fluid mt-4 px-4"
}
const _hoisted_37 = {
  key: 2,
  class: "error-state",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompareTable = _resolveComponent("CompareTable")!
  const _component_CompareTablePivot = _resolveComponent("CompareTablePivot")!
  const _component_CompareColumns = _resolveComponent("CompareColumns")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[11] || (_cache[11] = [
          _createElementVNode("div", {
            class: "spinner-border text-primary",
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Laden...")
          ], -1),
          _createElementVNode("p", { class: "mt-3" }, "Vergelijkingsweergave laden...", -1)
        ]))]))
      : (_ctx.compareConfig)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[25] || (_cache[25] = _createElementVNode("a", {
              class: "skip-link",
              href: "#hoofdinhoud"
            }, "Ga naar de projectenlijst", -1)),
            _createElementVNode("header", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.compareConfig.name), 1),
                    (_ctx.compareConfig.description)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.compareConfig.description), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn btn-custom", _ctx.currentView === 'list' ? 'btn-custom-active' : 'btn-custom-outline']),
                      "aria-pressed": _ctx.currentView === 'list',
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentView = 'list'))
                    }, [...(_cache[12] || (_cache[12] = [
                      _createElementVNode("i", {
                        class: "fas fa-list-ul me-1",
                        "aria-hidden": "true"
                      }, null, -1),
                      _createTextVNode(" Lijst ", -1)
                    ]))], 10, _hoisted_9),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn btn-custom", _ctx.currentView === 'table' ? 'btn-custom-active' : 'btn-custom-outline']),
                      "aria-pressed": _ctx.currentView === 'table',
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentView = 'table'))
                    }, [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("i", {
                        class: "fas fa-table me-1",
                        "aria-hidden": "true"
                      }, null, -1),
                      _createTextVNode(" Tabel ", -1)
                    ]))], 10, _hoisted_10),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn btn-custom", _ctx.currentView === 'compare' ? 'btn-custom-active' : 'btn-custom-outline']),
                      "aria-pressed": _ctx.currentView === 'compare',
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentView = 'compare')),
                      disabled: _ctx.selectedRecords.length === 0
                    }, [
                      _cache[14] || (_cache[14] = _createElementVNode("i", {
                        class: "fas fa-columns me-1",
                        "aria-hidden": "true"
                      }, null, -1)),
                      _cache[15] || (_cache[15] = _createTextVNode(" Vergelijk ", -1)),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.selectedRecords.length), 1),
                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "visually-hidden" }, "geselecteerde projecten", -1))
                    ], 10, _hoisted_11)
                  ])
                ])
              ])
            ]),
            _createElementVNode("main", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                (_ctx.compareConfig.searchConfig?.enabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _cache[19] || (_cache[19] = _createElementVNode("label", {
                        class: "visually-hidden",
                        for: "vergelijk-zoeken"
                      }, "Zoeken in projecten", -1)),
                      _createElementVNode("div", _hoisted_16, [
                        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "input-group-text" }, [
                          _createElementVNode("i", {
                            class: "fas fa-search",
                            "aria-hidden": "true"
                          })
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                          id: "vergelijk-zoeken",
                          type: "search",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchQuery) = $event)),
                          placeholder: "Zoeken...",
                          onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)))
                        }, null, 544), [
                          [_vModelText, _ctx.searchQuery]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args))),
                          "aria-label": "Zoekopdracht wissen"
                        }, [...(_cache[17] || (_cache[17] = [
                          _createElementVNode("i", {
                            class: "fas fa-times",
                            "aria-hidden": "true"
                          }, null, -1)
                        ]))])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.compareConfig.filters && _ctx.compareConfig.filters.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-custom-outline",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showFilters = !_ctx.showFilters)),
                        "aria-expanded": _ctx.showFilters,
                        "aria-controls": "vergelijk-filters"
                      }, [
                        _cache[20] || (_cache[20] = _createElementVNode("i", {
                          class: "fas fa-filter me-1",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _cache[21] || (_cache[21] = _createTextVNode(" Geavanceerd zoeken ", -1)),
                        (_ctx.hasActiveFilters)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Actief"))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_18)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFilters)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _cache[23] || (_cache[23] = _createElementVNode("h2", { class: "h6 mb-0" }, "Geavanceerd zoeken", -1)),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-outline-secondary",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showFilters = false)),
                            "aria-label": "Geavanceerd zoeken sluiten"
                          }, [...(_cache[22] || (_cache[22] = [
                            _createElementVNode("i", {
                              class: "fas fa-times",
                              "aria-hidden": "true"
                            }, null, -1)
                          ]))])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compareConfig.filters, (filter) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: filter.field,
                                class: "col-md-4 mb-3"
                              }, [
                                (filter.type === 'select')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("label", {
                                        class: "form-label fw-bold",
                                        for: 'filter-' + filter.field
                                      }, _toDisplayString(filter.label), 9, _hoisted_25),
                                      _withDirectives(_createElementVNode("select", {
                                        id: 'filter-' + filter.field,
                                        class: "form-select",
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.activeFilters[filter.field]) = $event),
                                        onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
                                      }, [
                                        _cache[24] || (_cache[24] = _createElementVNode("option", { value: "" }, "Alle", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFilterOptions(filter.field), (option) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: option,
                                            value: option
                                          }, _toDisplayString(option), 9, _hoisted_27))
                                        }), 128))
                                      ], 40, _hoisted_26), [
                                        [_vModelSelect, _ctx.activeFilters[filter.field]]
                                      ])
                                    ], 64))
                                  : (filter.type === 'checkbox' || filter.type === 'radio')
                                    ? (_openBlock(), _createElementBlock("fieldset", _hoisted_28, [
                                        _createElementVNode("legend", _hoisted_29, _toDisplayString(filter.label), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFilterOptions(filter.field), (option, i) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: option,
                                            class: "form-check"
                                          }, [
                                            _withDirectives(_createElementVNode("input", {
                                              id: 'filter-' + filter.field + '-' + i,
                                              type: filter.type,
                                              class: "form-check-input",
                                              name: 'filter-' + filter.field,
                                              value: option,
                                              "onUpdate:modelValue": ($event: any) => ((_ctx.activeFilters[filter.field]) = $event),
                                              onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
                                            }, null, 40, _hoisted_30), [
                                              [_vModelDynamic, _ctx.activeFilters[filter.field]]
                                            ]),
                                            _createElementVNode("label", {
                                              class: "form-check-label",
                                              for: 'filter-' + filter.field + '-' + i
                                            }, _toDisplayString(option), 9, _hoisted_31)
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("button", {
                              class: "btn btn-sm btn-outline-secondary",
                              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
                            }, "Reset")
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.filteredRecords.length) + " van " + _toDisplayString(_ctx.allRecords.length) + " projecten getoond. ", 1),
              (_ctx.currentView === 'list')
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createVNode(_component_CompareTable, {
                      records: _ctx.filteredRecords,
                      displayFields: _ctx.compareConfig.displayFields,
                      selectedRecords: _ctx.selectedRecords,
                      maxSelect: _ctx.maxSelectColumns,
                      fieldLabels: _ctx.getFieldLabels(),
                      onSelect: _ctx.toggleRecordSelection
                    }, null, 8, ["records", "displayFields", "selectedRecords", "maxSelect", "fieldLabels", "onSelect"])
                  ]))
                : (_ctx.currentView === 'table')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createVNode(_component_CompareTablePivot, {
                        records: _ctx.filteredRecords,
                        displayFields: _ctx.compareConfig.displayFields,
                        fieldLabels: _ctx.getFieldLabels()
                      }, null, 8, ["records", "displayFields", "fieldLabels"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createVNode(_component_CompareColumns, {
                        records: _ctx.getSelectedRecordData(),
                        compareFields: _ctx.compareConfig.compareFields,
                        fieldLabels: _ctx.getFieldLabels(),
                        onRemove: _ctx.removeFromCompare
                      }, null, 8, ["records", "compareFields", "fieldLabels", "onRemove"])
                    ]))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_37, [...(_cache[26] || (_cache[26] = [
            _createElementVNode("i", {
              class: "fas fa-exclamation-triangle",
              "aria-hidden": "true"
            }, null, -1),
            _createElementVNode("h1", null, "Configuratie niet gevonden", -1),
            _createElementVNode("p", null, "De opgevraagde vergelijkingsweergave kon niet worden geladen.", -1)
          ]))]))
  ]))
}